/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import Grid from '@material-ui/core/Grid';
import RenderTextField from '../../../../utils/renderFields/RenderTextField';
import RenderSelectField from '../../../../utils/renderFields/RenderSelectField';
import currency from '../../../../utils/bindings/currency';

/**
 * Formulaire permettant de mettre à jours la déclaration douanière
 * pour chaque produit
 *
 * @param {Object} fields       The Fields object
 * @param {Number} commandIndex Index de la commande actuelle
 */
const RenderCustomDeclarations = ({ fields, currentIndex }) => (
  <div>
    {fields.map((customsDeclaration, index) => (
      <div hidden={!(currentIndex === index)} key={index}>
        <Grid container spacing={2} key={index}>
          <Grid item md={12}>
            <Field
              name={`${customsDeclaration}.declaredValue`}
              label="Valeur déclarée"
              component={RenderTextField}
              displayErrorBeforeSubmit
              fullWidth
              type="text"
            />
          </Grid>
          <Grid item md={12}>
            <Field
              name={`${customsDeclaration}.currency`}
              label="Devise"
              component={RenderSelectField}
              displayErrorBeforeSubmit
              style={{ width: '100%' }}
              datas={currency}
              type="text"
            />
          </Grid>
          <Grid item md={12}>
            <Field
              name={`${customsDeclaration}.objectType`}
              label="Description douane"
              component={RenderTextField}
              displayErrorBeforeSubmit
              fullWidth
              type="text"
            />
          </Grid>
        </Grid>
      </div>
    ))}
  </div>
);

RenderCustomDeclarations.propTypes = {
  fields: PropTypes.object.isRequired,
  currentIndex: PropTypes.number.isRequired
};

export default RenderCustomDeclarations;
